import {
    houseRulesFragments,
    houseRulesV2Fragments,
} from '@homeaway/react-house-rules';
import gql from 'graphql-tag';

const rulesStepFragments = {
    HouseRules: gql`
        fragment RulesStepHouseRules on HouseRules {
            ...HouseRulesHouseRules
            ...HouseRulesV2HouseRules
        }
        ${houseRulesFragments.HouseRules}
        ${houseRulesV2Fragments.HouseRules}
    `,
    CheckoutExperienceModel: gql`
        fragment RulesStepCheckoutExperienceModel on CheckoutExperienceModel {
            policies {
                type
                label
                description
                url
                houseRules
                contractAddendum
                damageLiability {
                    damageLiabilityAmount {
                        amount
                        currency
                        localized
                    }
                    daysRemaining
                }
            }
            cancellationPolicy {
                cancellationPolicyLabel {
                    label
                    date
                    isFullRefundWindow
                }
                cancellationPolicyPeriods {
                    label
                }
                cancellationTimelinePeriods {
                    refundPercent
                    shortDateLocalized
                }
                unstructuredPolicyFreeText
                policyType
            }
        }
    `,
};

export default rulesStepFragments;
